import { lazy } from 'react';
import { useModal } from 'src/components/modal';
import { ChatDetailsTitle } from './constants';

export { ChatDetailsTitle } from './constants';

const Component = lazy(() =>
  import('./ChatDetailsDialog').then((module) => ({
    default: module.ChatDetailsDialog,
  })),
);

export const useChatDetailsDialog = () => {
  const { hideModal, showModal } = useModal(Component, []);

  return {
    hideChatDetailsDialog: hideModal,
    showChatDetailsDialog: (data: {
      conversationId: string;
      tab?: ChatDetailsTitle;
    }) => showModal(data),
  };
};
